import { useEffect, useState } from "react";
import "../../Css/Common.css";
import $ from "jquery";
import Popups from "../Modals/Popups";
import PersonalizedActionModal from "../Modals/PersonalizedActionModal";
import { Link, useLocation } from "react-router-dom";

export function NewNavbar() {
  const [state, setState] = useState({});
  const location = useLocation();
  const [show, setShow] = useState(false);
  var width = $(window).width();
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    $("#navbarNavDropdown").removeClass("show");
    activeNavigation();
    return () => {
      setState({});
    };
  }, []);
  const isSticky = (e) => {
    const header = document.querySelector(".navbarfixedPos");
    const scrollTop = window.scrollY;
    if (scrollTop > 0) {
      header.classList.add("is-sticky");
    } else {
      header.classList.remove("is-sticky");
    }
  };
  const activeNavigation = () => {
    var PathName = window.location.pathname;
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let foo = params.get("page");
    $(".nav-link").removeClass("activeNav");
    $(".dropdown-item").removeClass("activeNav");
    if (PathName == "/portfolio") {
      $("#PortfolioId").addClass("activeNav");
    } else if (foo == "whatwedo") {
      $("#whatwedoId").addClass("activeNav");
      window.scroll(0, size1);
    } else if (foo == "whoweare") {
      $("#whoweareId").addClass("activeNav");
      window.scroll(0, size3);
    } else if (PathName == "/about-us") {
      $("#AboutUs").addClass("activeNav");
    } else if (PathName.includes("/career")) {
      $("#Career").addClass("activeNav");
    } else if (PathName.includes("/blog")) {
      $("#Blog").addClass("activeNav");
    } else if (PathName == "/contact-us") {
      $("#ContactUsId").addClass("activeNav");
    }
  };
  var width = $(window).width();
  var size1 = 650;
  var size2 = 3500;
  var size3 = 6700;
  if (width <= 991) {
    size1 = 500;
    size2 = 5250;
    size3 = 8850;
  }
  const CheckDropdownOpen = () => {
    if (width <= 991) {
      if ($("#DropdownMenuId").hasClass("d-none")) {
        $("#DropdownMenuId").removeClass("d-none");
        $("#DropdownMenuId").css("display", "block");
      } else {
        $("#DropdownMenuId").addClass("d-none");
        $("#DropdownMenuId").css("display", "none");
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    $("#navbarNavDropdown").removeClass("show");
    activeNavigation();
    return () => {
      setState({});
      window.removeEventListener("scroll", isSticky);
    };
  }, [location]);
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark NavBgColor navbarfixedPos px-0">
        <div className="container-fluid mt-2 px-4">
          <Link className="navbar-brand me-0" to="/">
            <img
              src="/images/NavLogo.svg"
              alt="SprigStack footer Logo"
              title="SprigStack Software development Company"
            />
          </Link>
          <button
            className="navbar-toggler mt-4 me-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse mt-1 justify-content-end"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav d-flex alignItemsCenter">
              <li className="nav-item px-3">
                <Link
                  className="nav-link"
                  id="ai-development-services"
                  to="/ai-development-services"
                >
                  <button class="ai-button">
                    <div class="dots_border"></div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      class="sparkle"
                    >
                      <path
                        class="path"
                        stroke-linejoin="round"
                        stroke-linecap="round"
                        stroke="black"
                        fill="black"
                        d="M14.187 8.096L15 5.25L15.813 8.096C16.0231 8.83114 16.4171 9.50062 16.9577 10.0413C17.4984 10.5819 18.1679 10.9759 18.903 11.186L21.75 12L18.904 12.813C18.1689 13.0231 17.4994 13.4171 16.9587 13.9577C16.4181 14.4984 16.0241 15.1679 15.814 15.903L15 18.75L14.187 15.904C13.9769 15.1689 13.5829 14.4994 13.0423 13.9587C12.5016 13.4181 11.8321 13.0241 11.097 12.814L8.25 12L11.096 11.187C11.8311 10.9769 12.5006 10.5829 13.0413 10.0423C13.5819 9.50162 13.9759 8.83214 14.186 8.097L14.187 8.096Z"
                      ></path>
                      <path
                        class="path"
                        stroke-linejoin="round"
                        stroke-linecap="round"
                        stroke="black"
                        fill="black"
                        d="M6 14.25L5.741 15.285C5.59267 15.8785 5.28579 16.4206 4.85319 16.8532C4.42059 17.2858 3.87853 17.5927 3.285 17.741L2.25 18L3.285 18.259C3.87853 18.4073 4.42059 18.7142 4.85319 19.1468C5.28579 19.5794 5.59267 20.1215 5.741 20.715L6 21.75L6.259 20.715C6.40725 20.1216 6.71398 19.5796 7.14639 19.147C7.5788 18.7144 8.12065 18.4075 8.714 18.259L9.75 18L8.714 17.741C8.12065 17.5925 7.5788 17.2856 7.14639 16.853C6.71398 16.4204 6.40725 15.8784 6.259 15.285L6 14.25Z"
                      ></path>
                      <path
                        class="path"
                        stroke-linejoin="round"
                        stroke-linecap="round"
                        stroke="black"
                        fill="black"
                        d="M6.5 4L6.303 4.5915C6.24777 4.75718 6.15472 4.90774 6.03123 5.03123C5.90774 5.15472 5.75718 5.24777 5.5915 5.303L5 5.5L5.5915 5.697C5.75718 5.75223 5.90774 5.84528 6.03123 5.96877C6.15472 6.09226 6.24777 6.24282 6.303 6.4085L6.5 7L6.697 6.4085C6.75223 6.24282 6.84528 6.09226 6.96877 5.96877C7.09226 5.84528 7.24282 5.75223 7.4085 5.697L8 5.5L7.4085 5.303C7.24282 5.24777 7.09226 5.15472 6.96877 5.03123C6.84528 4.90774 6.75223 4.75718 6.697 4.5915L6.5 4Z"
                      ></path>
                    </svg>
                    <span class="text_button">AI</span>
                  </button>
                </Link>
              </li>
              <li
                className="nav-item dropdown px-3"
                onClick={CheckDropdownOpen}
              >
                <span className="nav-link dropdown-toggle active align-items-center d-flex adminlink">
                  Services
                  <img
                    className="ps-1 rotate h-8"
                    src="/images/down_arrow.png"
                    alt=""
                  />
                </span>
                <ul
                  className="dropdown-menu d-none text-m-center mobile"
                  aria-labelledby="navbarDropdownMenuLink"
                  id="DropdownMenuId"
                >
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65 adminlink"
                      id="WebDevelopment"
                      to="/web-development"
                    >
                      Web Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="WebApp"
                      to="/web-application-development"
                    >
                      Web App development
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="Ecommerce"
                      to="/ecommerce-services"
                    >
                    Ecommerce Services
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="AppDevelopment"
                      to="/mobile-app-development"
                    >
                      Mobile App Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="ApiIntegration"
                      to="/api-integration-services"
                    >
                      API Integration
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="CrmDevelopment"
                      to="/crm-development-services"
                    >
                      CRM Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="ErpDevelopment"
                      to="/erp-development-services"
                    >
                      ERP Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-50 adminlink"
                      id="UIUXDesigns"
                      to="/uiux-design"
                    >
                      UI/UX Design
                    </Link>
                  </li>
                  <li className="desktop">
                    <Link
                      className="nav-link dropdown-item w-100 adminlink"
                      id="SeoId"
                      to="/seo"
                    >
                      Search Engine Optimization
                    </Link>
                  </li>
                  <li className="mobile">
                    <Link
                      className="nav-link dropdown-item adminlink"
                      id="SeoId"
                      to="/seo"
                    >
                      Search Engine <br /> Optimization
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-25 adminlink"
                      id="SeoId"
                      to="/devops"
                    >
                      DevOps
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-77 adminlink"
                      id="SeoId"
                      to="/project-management"
                    >
                      Project Management
                    </Link>
                  </li>
                </ul>
                <ul
                  className="dropdown-menu text-m-center desktop"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65 adminlink"
                      id="WebDevelopment"
                      to="/web-development"
                    >
                      Web Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="WebApp"
                      to="/web-application-development"
                    >
                      Web App development
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="Ecommerce"
                      to="/ecommerce-services"
                    >
                    Ecommerce Services
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="AppDevelopment"
                      to="/mobile-app-development"
                    >
                      Mobile App Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="ApiIntegration"
                      to="/api-integration-services"
                    >
                      API Integration
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="CrmDevelopment"
                      to="/crm-development-services"
                    >
                      CRM Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-65  adminlink"
                      id="ErpDevelopment"
                      to="/erp-development-services"
                    >
                      ERP Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-50 adminlink"
                      id="UIUXDesigns"
                      to="/uiux-design"
                    >
                      UI/UX Design
                    </Link>
                  </li>
                  <li className="desktop">
                    <Link
                      className="nav-link dropdown-item w-100 adminlink"
                      id="SeoId"
                      to="/seo"
                    >
                      Search Engine Optimization
                    </Link>
                  </li>
                  <li className="mobile">
                    <Link
                      className="nav-link dropdown-item adminlink"
                      id="SeoId"
                      to="/seo"
                    >
                      Search Engine <br /> Optimization
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-25 adminlink"
                      id="SeoId"
                      to="/devops"
                    >
                      DevOps
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="nav-link dropdown-item w-77 adminlink"
                      id="SeoId"
                      to="/project-management"
                    >
                      Project Management
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item px-3 adminlink">
                <Link className="nav-link" id="PortfolioId" to="/portfolio">
                  Portfolio
                </Link>
              </li>
              <li className="nav-item px-3 adminlink">
                <Link className="nav-link" id="AboutUs" to="/about-us">
                  About Us
                </Link>
              </li>
              <li className="nav-item px-3 adminlink">
                <Link className="nav-link" id="Career" to="/career">
                  Career
                </Link>
              </li>
              <li className="nav-item px-3 adminlink">
                <Link className="nav-link" id="Blog" to="/blog">
                  Blog
                </Link>
              </li>

              <li className="nav-item px-3 adminlink">
                <Link
                  className="nav-link "
                  id="ContactUsId"
                  to="contact-us"
                  state={{ pathname: location?.pathname }}
                >
                  Contact Us
                </Link>
              </li>
              {width <= 576 ? (
                <li className="nav-item px-3 adminlink">
                  <Link
                    className="nav-link"
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    FREE QUOTE
                  </Link>
                </li>
              ) : (
                <li className="ps-3">
                  <button
                    className="freeQuoteBtn"
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    <b>FREE QUOTE</b>
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
      <Popups show={show} setShow={setShow} title="FREE CONSULTATION" size="lg">
        <PersonalizedActionModal modalSource="(Free Quote)" />
      </Popups>
    </>
  );
}
